(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide_1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tac-size-guide')) return;

    var FURN = {
      sofa: { label: 'Sofa', w: 220, h: 85 },
      bed: { label: 'Bed', w: 180, h: 110 },
      console: { label: 'Console', w: 140, h: 80 },
      dining: { label: 'Dining table', w: 200, h: 75 },
      desk: { label: 'Desk', w: 120, h: 75 },
      bench: { label: 'Bench', w: 140, h: 45 },
      fireplace: { label: 'Fireplace', w: 150, h: 110 },
      wall: { label: 'Wall only', w: 0, h: 0 }
    };
    var LIMITS = { wallW: [100, 800], wallH: [200, 400], furnW: [60, 400] };

    function b(style) { return '<i style="' + style + '"></i>'; }
    var G1 = '#EDEDED', G2 = '#E2E2E2', G3 = '#D4D4D4', G4 = '#C8C8C8', DK = '#262626';
    var SHAPES = {
      sofa: [
        b('left:7%;right:7%;top:0;height:52%;background:' + G2 + ';border-radius:10px 10px 3px 3px'),
        b('left:8%;width:41.5%;top:42%;height:30%;background:' + G1 + ';border-radius:4px'),
        b('left:50.5%;width:41.5%;top:42%;height:30%;background:' + G1 + ';border-radius:4px'),
        b('left:0;width:9%;top:28%;height:60%;background:' + G3 + ';border-radius:12px 12px 3px 3px'),
        b('right:0;width:9%;top:28%;height:60%;background:' + G3 + ';border-radius:12px 12px 3px 3px'),
        b('left:2%;right:2%;top:72%;height:16%;background:' + G3 + ';border-radius:3px'),
        b('left:6%;width:1.5%;top:88%;height:12%;background:' + DK),
        b('right:6%;width:1.5%;top:88%;height:12%;background:' + DK)
      ].join(''),
      bed: [
        b('left:0;right:0;top:0;height:72%;background:' + G4 + ';border-radius:8px 8px 0 0'),
        b('left:12%;width:33%;top:34%;height:16%;background:#F7F7F7;border-radius:6px'),
        b('right:12%;width:33%;top:34%;height:16%;background:#F7F7F7;border-radius:6px'),
        b('left:2%;right:2%;top:48%;height:14%;background:#EDEDED'),
        b('left:0;right:0;top:58%;height:32%;background:' + G2 + ';border-radius:3px'),
        b('left:3%;width:2.5%;top:90%;height:10%;background:' + DK),
        b('right:3%;width:2.5%;top:90%;height:10%;background:' + DK)
      ].join(''),
      console: [
        b('left:0;right:0;top:0;height:6%;background:' + DK),
        b('left:4%;width:2%;top:6%;height:94%;background:' + DK),
        b('right:4%;width:2%;top:6%;height:94%;background:' + DK),
        b('left:4%;right:4%;top:76%;height:4%;background:' + DK)
      ].join(''),
      dining: [
        b('left:0;right:0;top:0;height:7%;background:' + DK),
        b('left:4%;right:4%;top:7%;height:7%;background:#9E9E9E'),
        b('left:6%;width:3%;top:14%;height:86%;background:' + DK),
        b('right:6%;width:3%;top:14%;height:86%;background:' + DK)
      ].join(''),
      desk: [
        b('left:0;right:0;top:0;height:7%;background:' + DK),
        b('right:5%;width:36%;top:7%;height:30%;background:' + G2),
        b('right:19%;width:8%;top:21%;height:2px;background:' + DK),
        b('left:3%;width:2%;top:7%;height:93%;background:' + DK),
        b('right:3%;width:2%;top:7%;height:93%;background:' + DK)
      ].join(''),
      bench: [
        b('left:0;right:0;top:0;height:32%;background:' + G2 + ';border-radius:4px'),
        b('left:1%;right:1%;top:32%;height:8%;background:' + DK),
        b('left:6%;width:3%;top:40%;height:60%;background:' + DK),
        b('right:6%;width:3%;top:40%;height:60%;background:' + DK)
      ].join(''),
      fireplace: [
        b('left:5%;right:5%;top:8%;bottom:0;background:#EDEDED;border:1px solid ' + G3 + ';box-sizing:border-box'),
        b('left:0;right:0;top:0;height:8%;background:' + DK),
        b('left:28%;right:28%;top:38%;bottom:0;background:#2B2B2B;border-radius:40% 40% 0 0 / 22% 22% 0 0')
      ].join('')
    };

    /* artwork drawings. "frame" is the wood colour, like your frame options */
    /* artwork drawings, from soft and light to dark and bold */
    var ARTS = [
      { key: 'lilies', name: 'Water Lilies', tone: 'Soft', html: '<div class="tsg__ai tsg__ai--lilies"></div>' },
      { key: 'kiss', name: 'The Kiss', tone: 'Gold', html: '<div class="tsg__ai tsg__ai--kiss"><i class="tsg__k1"></i><i class="tsg__k2"></i><i class="tsg__k3"></i><i class="tsg__k4"></i><i class="tsg__k5"></i></div>' },
      { key: 'wheat', name: 'Wheat Field', tone: 'Bright', html: '<div class="tsg__ai tsg__ai--wheat"><i class="tsg__w1"></i><i class="tsg__w2"></i><i class="tsg__w3"></i><i class="tsg__w4"></i></div>' },
      { key: 'starry', name: 'Starry Night', tone: 'Dark', html: '<div class="tsg__ai tsg__ai--starry"><i class="tsg__s1"></i><i class="tsg__s2"></i><i class="tsg__s3"></i></div>' },
      { key: 'wave', name: 'The Great Wave', tone: 'Light', html: '<div class="tsg__ai tsg__ai--wave"><i class="tsg__g4"></i><i class="tsg__g3"></i><i class="tsg__g1"></i><i class="tsg__g2"></i></div>' },
      { key: 'sun', name: 'Sunflowers', tone: 'Vivid', html: '<div class="tsg__ai tsg__ai--sun"><i class="tsg__u1"></i></div>' },
      { key: 'sunrise', name: 'Impression, Sunrise', tone: 'Muted', html: '<div class="tsg__ai tsg__ai--sunrise"><i class="tsg__r5"></i><i class="tsg__r1"></i><i class="tsg__r2"></i><i class="tsg__r3"></i><i class="tsg__r4"></i></div>' },
      { key: 'pearl', name: 'Pearl Earring', tone: 'Dark', html: '<div class="tsg__ai tsg__ai--pearl"><i class="tsg__p5"></i><i class="tsg__p3"></i><i class="tsg__p1"></i><i class="tsg__p2"></i><i class="tsg__p4"></i></div>' },
      { key: 'grid', name: 'Composition', tone: 'Bold', html: '<div class="tsg__ai tsg__ai--grid"><i class="tsg__m1"></i><i class="tsg__m2"></i><i class="tsg__m3"></i><i class="tsg__m4"></i><i class="tsg__m5"></i><i class="tsg__m6"></i><i class="tsg__m7"></i><i class="tsg__m8"></i></div>' },
      { key: 'line', name: 'Line Art', tone: 'Light', html: '<div class="tsg__ai tsg__ai--line"><i class="tsg__l1"></i><i class="tsg__l2"></i><i class="tsg__l3"></i></div>' }
    ];
    var FRAME_CM = 2.5;

    var SIZE_RE = /(\d+(?:\.\d+)?)\s*(?:cm)?\s*[x×X*]\s*(\d+(?:\.\d+)?)/;

    function clamp(v, a, c) { v = Number(v); if (!isFinite(v)) v = a; return Math.max(a, Math.min(c, v)); }
    function pct(v, t) { return (v / t * 100).toFixed(3) + '%'; }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }

    function parseList(text, order) {
      var out = [];
      String(text || '').split(/[,\n;]+/).forEach(function (part) {
        var m = part.match(SIZE_RE);
        if (!m) return;
        var a = Number(m[1]), c = Number(m[2]);
        var pair = order === 'hw' ? [c, a] : [a, c];
        if (!out.some(function (p) { return p[0] === pair[0] && p[1] === pair[1]; })) out.push(pair);
      });
      return out.sort(function (x, y) { return x[0] * x[1] - y[0] * y[1]; });
    }

    class TacSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var cfgEl = this.querySelector('[data-tsg-config]');
        this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {};
        var c = this.cfg;
        this.sets = {
          square: parseList(c.square, 'wh'),
          vertical: parseList(c.vertical, 'wh'),
          horizontal: parseList(c.horizontal, 'wh')
        };
        this.productSizes = null;
        this.customLimits = [Number(c.customMin) || 20, Number(c.customMax) || 200];
        this.state = {
          furniture: 'sofa', furnW: 220, wallW: 360,
          wallH: clamp(Number(c.wallH) || 230, LIMITS.wallH[0], LIMITS.wallH[1]),
          shape: 'vertical', pieces: Number(c.pieces) || 1, sizeIdx: null,
          custom: false, customW: 50, customH: 70, art: 0, frame: 'natural'
        };
        this.arts = ARTS.slice();
        this.syncInputs();
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('input', this.onInput.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.render();
        this.loadProduct();
      }

      q(sel) { return this.querySelector(sel); }
      qa(sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); }
      isCustomField(f) { return f === 'customW' || f === 'customH'; }
      limits(f) { return this.isCustomField(f) ? this.customLimits : LIMITS[f]; }

      syncInputs() {
        var self = this;
        this.qa('input[data-tsg-field]').forEach(function (inp) { inp.value = self.state[inp.dataset.tsgField]; });
      }

      onClick(e) {
        var t = e.target.closest('button');
        if (!t || !this.contains(t)) return;
        var s = this.state, d = t.dataset;
        if (d.tsgArt != null) {
          s.art = Number(d.tsgArt);
        } else if (d.tsgFrame) {
          s.frame = d.tsgFrame;
        } else if (d.tsgFurniture) {
          s.furniture = d.tsgFurniture;
          if (FURN[s.furniture].w) s.furnW = FURN[s.furniture].w;
          s.sizeIdx = null;
          this.syncInputs();
        } else if (d.tsgShape) {
          s.shape = d.tsgShape; s.sizeIdx = null; s.custom = false;
        } else if (d.tsgPieces) {
          s.pieces = Number(d.tsgPieces); s.sizeIdx = null;
        } else if (d.tsgSize != null) {
          s.sizeIdx = Number(d.tsgSize); s.custom = false;
        } else if (t.hasAttribute('data-tsg-custom')) {
          s.custom = true;
        } else if (d.tsgStep) {
          var f = d.tsgStep, lim = this.limits(f);
          s[f] = clamp(clamp(s[f], lim[0], lim[1]) + Number(d.tsgDelta), lim[0], lim[1]);
          if (this.isCustomField(f)) s.custom = true;
          var inp = this.q('input[data-tsg-field="' + f + '"]');
          if (inp) inp.value = s[f];
        } else {
          return;
        }
        this.render();
      }

      onInput(e) {
        var f = e.target.dataset && e.target.dataset.tsgField;
        if (!f) return;
        this.state[f] = e.target.value === '' ? '' : Number(e.target.value);
        if (this.isCustomField(f)) this.state.custom = true;
        this.render();
      }

      onChange(e) {
        var f = e.target.dataset && e.target.dataset.tsgField;
        if (!f) return;
        var lim = this.limits(f);
        this.state[f] = clamp(e.target.value, lim[0], lim[1]);
        e.target.value = this.state[f];
        this.render();
      }

      loadProduct() {
        var self = this;
        var handle = new URLSearchParams(window.location.search).get('product');
        if (!handle) return;
        var root = this.cfg.root || '/';
        if (root.slice(-1) !== '/') root += '/';
        fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            var wanted = String(self.cfg.sizeOption || 'Size').toLowerCase();
            var opt = (p.options || []).find(function (o) {
              var n = String(o.name || '').toLowerCase();
              return n === wanted || n.indexOf('size') !== -1 || n.indexOf('مقاس') !== -1;
            });
            var sizes = parseList((opt ? opt.values : []).join(','), self.cfg.sizeOrder);
            var img = p.featured_image || (p.images && p.images[0]);
            if (img) {
              if (img.indexOf('//') === 0) img = 'https:' + img;
              img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=600';
              self.arts = [{ key: 'product', name: 'This artwork', tone: 'Photo', photo: img }].concat(ARTS);
              self.state.art = 0;
            }
            if (!sizes.length) { self.render(); return; }
            self.productSizes = sizes;
            self.state.sizeIdx = null;
            self.q('[data-tsg-product]').hidden = false;
            self.q('[data-tsg-product-name]').textContent = p.title;
            self.render();
          })
          .catch(function () {});
      }

      render() {
        var s = this.state, c = this.cfg;
        var gap = Number(c.gap) || 5, above = Number(c.above) || 20, lift = c.lift != null ? Number(c.lift) : 8;
        var f = FURN[s.furniture];
        var hasF = s.furniture !== 'wall';
        var wallW = clamp(s.wallW, 100, 800);
        var wallH = clamp(s.wallH, 200, 400);
        var furnW = hasF ? Math.min(clamp(s.furnW, 60, 400), wallW) : 0;
        var n = s.pieces;
        var sizes = this.productSizes || this.sets[s.shape];
        if (!sizes || !sizes.length) sizes = [[40, 60]];
        var groupOf = function (p) { return n * p[0] + (n - 1) * gap; };
        var limit = hasF ? furnW : wallW * 0.8;
        var start = Math.floor((sizes.length - 1) / 2);

        var cl = this.customLimits;
        var hasCustomUI = !!this.q('[data-tsg-custom-panel]');
        var isCustom = hasCustomUI && !!s.custom;
        var sel = isCustom ? -1 : ((s.sizeIdx == null || s.sizeIdx >= sizes.length) ? start : s.sizeIdx);
        var cur = isCustom ? [clamp(s.customW, cl[0], cl[1]), clamp(s.customH, cl[0], cl[1])] : sizes[sel];
        var w = cur[0], h = cur[1], gW = groupOf(cur);

        var floorClear = hasF ? f.h + 5 : 10;
        var bottom = hasF ? f.h + above : wallH / 2 + lift - h / 2;
        if (bottom + h > wallH - 8) bottom = Math.max(floorClear, wallH - 8 - h);
        var startX = wallW / 2 - gW / 2;

        /* static control states */
        this.qa('[data-tsg-furniture]').forEach(function (el) { el.setAttribute('aria-pressed', String(el.dataset.tsgFurniture === s.furniture)); });
        this.qa('[data-tsg-shape]').forEach(function (el) { el.setAttribute('aria-pressed', String(!isCustom && el.dataset.tsgShape === s.shape)); });
        this.qa('[data-tsg-pieces]').forEach(function (el) { el.setAttribute('aria-pressed', String(Number(el.dataset.tsgPieces) === n)); });
        if (hasCustomUI) {
          this.q('[data-tsg-custom-panel]').classList.toggle('is-active', isCustom);
          this.q('[data-tsg-custom-tag]').hidden = !isCustom;
          this.q('[data-tsg-custom]').hidden = isCustom;
        }
        this.q('[data-tsg-furn-field]').hidden = !hasF;
        var furnLabel = this.q('label[for$="-furnW"]');
        if (furnLabel) furnLabel.textContent = f.label + ' width';
        this.q('[data-tsg-shape-group]').hidden = !!this.productSizes;
        this.q('[data-tsg-wall-label]').textContent = wallW + ' × ' + wallH + ' cm';

        /* artwork picker */
        var arts = this.arts;
        if (s.art >= arts.length) s.art = 0;
        var artInner = function (a) {
          return a.photo
            ? '<img class="tsg__photo" src="' + esc(a.photo) + '" alt="" loading="lazy">'
            : a.html;
        };
        var frameOf = function (a) { return a.photo ? 'photo' : s.frame; };
        this.q('[data-tsg-arts]').innerHTML = arts.map(function (a, i) {
          return '<button type="button" class="tsg__artbtn" data-tsg-art="' + i + '" aria-pressed="' + (i === s.art) + '">' +
            '<span class="tsg__thumb tsg__frame--' + frameOf(a) + '"><span class="tsg__art">' + artInner(a) + '</span></span>' +
            '<span>' + esc(a.name) + '</span><span class="tsg__arttone">' + esc(a.tone) + '</span></button>';
        }).join('');
        /* product photos already show the frame, so the frame choice is for the drawings */
        this.q('[data-tsg-frame-group]').hidden = !!arts[s.art].photo;
        this.qa('[data-tsg-frame]').forEach(function (el) { el.setAttribute('aria-pressed', String(el.dataset.tsgFrame === s.frame)); });

        /* size list */
        this.q('[data-tsg-sizes]').innerHTML = sizes.map(function (p, i) {
          var on = i === sel;
          return '<button type="button" class="tsg__size" data-tsg-size="' + i + '" aria-pressed="' + on + '">' +
            p[0] + ' × ' + p[1] + ' cm</button>';
        }).join('');

        /* scene */
        var scene = this.q('[data-tsg-scene]');
        scene.style.aspectRatio = wallW + ' / ' + wallH;
        var html = '';
        var lineB = Math.min(bottom + h + 6, wallH - 16);
        html += '<div class="tsg__hdim" style="left:' + pct(startX, wallW) + ';width:' + pct(gW, wallW) + ';bottom:' + pct(lineB, wallH) + '"><span>' + gW + ' cm</span></div>';
        var hx = Math.max(startX - 8, 3);
        html += '<div class="tsg__vdim" style="left:' + pct(hx, wallW) + ';bottom:' + pct(bottom, wallH) + ';height:' + pct(h, wallH) + '"><span>' + h + ' cm</span></div>';
        var chosen = arts[s.art];
        for (var i = 0; i < n; i++) {
          /* in a set, the other pieces show the next drawings (a photo stays the same) */
          var a = chosen.photo ? chosen : (function () {
            var drawn = arts.filter(function (x) { return !x.photo; });
            var k = drawn.indexOf(chosen);
            return drawn[(k + i) % drawn.length];
          })();
          var noBorder = a.photo || s.frame === 'none';
          var fx = noBorder ? 0 : Math.min(FRAME_CM, w / 6) / w * 100;
          var fy = noBorder ? 0 : Math.min(FRAME_CM, h / 6) / h * 100;
          html += '<div class="tsg__frame tsg__frame--' + frameOf(a) + '" style="left:' + pct(startX + i * (w + gap), wallW) + ';bottom:' + pct(bottom, wallH) +
            ';width:' + pct(w, wallW) + ';height:' + pct(h, wallH) + '">' +
            '<div class="tsg__art" style="left:' + fx.toFixed(3) + '%;right:' + fx.toFixed(3) + '%;top:' + fy.toFixed(3) + '%;bottom:' + fy.toFixed(3) + '%">' +
            artInner(a) + '</div></div>';
        }
        var fLeft = (wallW - furnW) / 2;
        if (hasF) {
          html += '<div class="tsg__furn" aria-hidden="true" style="left:' + pct(fLeft, wallW) + ';width:' + pct(furnW, wallW) + ';height:' + pct(f.h, wallH) + '">' + SHAPES[s.furniture] + '</div>';
        }
        scene.innerHTML = html;

        var floor = this.q('[data-tsg-floor]');
        floor.innerHTML = hasF
          ? '<div class="tsg__hdim tsg__hdim--below" style="top:10px;left:' + pct(fLeft, wallW) + ';width:' + pct(furnW, wallW) + '"><span>' + esc(f.label) + ' · ' + furnW + ' cm</span></div>'
          : '';
        floor.hidden = !hasF;

        /* warnings */
        this.q('[data-tsg-warn-wide]').hidden = !(gW > limit + 0.5);
        this.q('[data-tsg-warn-tall]').hidden = !(h > wallH - floorClear - 25);
      }
    }

    customElements.define('tac-size-guide', TacSizeGuide);
  })();

  } catch(e) { console.error(e); }
})();
})();
